import { Outlet } from 'react-router-dom'
import React from 'react'

const Profile = () => {
  return (
    <Outlet/>
  )
}

export default Profile